import getV10APIs from './v1.0';
import { mergeVersionsByTitle } from '../../../util/HelperFunctions';

const data = (userInfo) => {
  const v10APIs = getV10APIs(userInfo);

  const children = [
    mergeVersionsByTitle('메모 등록', v10APIs),
    mergeVersionsByTitle('메모 삭제', v10APIs),
    mergeVersionsByTitle('메모 수정', v10APIs),
  ].filter(Boolean);

  return { title: '메모', children };
};

export default data;
